import React from "react";
import Services from "../components/Services";
import Process from "../components/Process";

const ServicesPage: React.FC = () => (
  <>
    <Services />
    <Process />
  </>
);

export default ServicesPage;
